import React from "react";
import styled from "styled-components";

const InfoFooterSection = ({ children }) => (
  <StyledComponent>{children}</StyledComponent>
);

export default InfoFooterSection;

const StyledComponent = styled.div`
  margin: 20px 0;
  @media (min-width: 768px) {
    margin: 0 20px;
  }
`;
